import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'

import BootstrapAlert from '../element/BootstrapAlert'
import Transit from '../Transit'
import ErrorBoundary from '../ErrorBoundary'

/* autocomplete */
function MultipleSelector (shareGroupMembers, optionList, addList, setter, onAddButtonClick) {
  const modalRef = useRef(null)
  const [addingForeign, setAddingForeign] = useState(false)

  function modalOpen () {
    const membersDomainMap = new Map(shareGroupMembers.map((member) => [member.user.email.split('@')[1], 1]))
    setAddingForeign(addList.some((user) => !membersDomainMap.has(user.email.split('@')[1])))
    $(modalRef.current).modal('show')
  }

  return (
    <>
      <div className="my-input-root">
        <div className="d-flex">
          <Autocomplete
            multiple
            id="add-list"
            className='flex-fill'
            options={optionList}
            getOptionLabel={(option) => `${option.name}【${option.company.name}】<${option.email}>`}
            defaultValue={[]}
            value={addList}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="追加するユーザーを選択"
                placeholder=""
              />
            )}
            onChange={(e, value) => setter(value)}
          />
          <button type="button" className="btn bg-theme-success p-2" onClick={() => modalOpen()}>+</button>
        </div>
      </div>
      {/* -- 確認ダイアログ -- */}
      <div ref={modalRef} className="modal fade" id="addModal" tabIndex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addModalLabel">メンバーを追加</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <BootstrapAlert class="danger">
                <div>追加するとグループ内のメンバーと申請情報が共有されます。</div>
              </BootstrapAlert>
              {addingForeign && (
                <BootstrapAlert class="danger">
                  <div>現メンバーと異なる会社のアカウントが追加されようとしている可能性があります。</div>
                </BootstrapAlert>
              )}
              追加しますか？<br/>
              ※「更新」ボタンを押すまで変更は確定されません。
            </div>
            <div className="modal-footer">
              <button type="button" className="btn bg-theme-primary" onClick={(e) => {
                onAddButtonClick()
                $('#addModal').modal('hide')
              }}>追加</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default function ShareGroupEdit (props) {
  const maxLength = {
    name: 170,
    comment: 170,
    sp_comment: 170
  }
  const {
    shareGroup,
    users,
    postUrl,
    createMode,
    editable,
    isShopro
  } = props
  const [addList, setAddList] = useState([])
  const [memberList, setMemberList] = useState([])
  const [editMode, setEditMode] = useState(createMode)
  const [inTransit, setInTransit] = useState(false)

  useEffect(() => {
    setMemberList(
      createMode
        ? users.filter((user) => user.is_me)
        : shareGroup.share_group_members.map((member) => { return { ...member.user, nowMember: true } })
    )
  }, [editMode])

  useEffect(() => {
    if (inTransit) {
      setTimeout(() => { setInTransit(false) }, 200)
    }
  }, [inTransit])

  function getUsersNotInGroup (users) {
    return users.filter(
      (user) => memberList.findIndex(
        (member) => member.id === user.id
      ) === -1
    )
  }

  const onAddButtonClick = () => {
    setMemberList(memberList.concat(addList))
    setAddList([])
  }

  const removeMember = (id) => {
    setMemberList(memberList.filter((member) => member.id !== id))
  }

  return (
    <form action={createMode ? postUrl.store : postUrl.update} method="POST">
      <input type="text" name="_token" className="d-none" readOnly value={$('meta[name="csrf-token"]').attr('content')} />
      <input type="text" name="members_json" className="d-none" readOnly value={JSON.stringify(memberList, ['id'])} />
      {Transit({
        element: (
        <React.Fragment>
          <div className="row mb-3">
            <div className="col-6">
              <h5 className="mb-3">基本情報</h5>
              <div className="my-input-root">
                <TextField className="w-100" name="name" label="グループ名" InputProps={{ readOnly: !editMode }} inputProps={{ maxLength: maxLength.name }}
                  defaultValue={shareGroup.name} required/>
              </div>
              <div className="my-input-root">
                <TextField className="w-100" name="comment" label={`メモ${isShopro ? '（ライセンシー用）' : ''}`} InputProps={{ readOnly: !editMode }} inputProps={{ maxLength: maxLength.comment }}
                  defaultValue={shareGroup.comment} multiline minRows={2}/>
              </div>
              {isShopro && (
                <div className="my-input-root">
                  <TextField className="w-100" name="sp_comment" label="メモ（ShoPro用）" InputProps={{ readOnly: !editMode }} inputProps={{ maxLength: maxLength.sp_comment }}
                    defaultValue={shareGroup.sp_comment} multiline minRows={2}/>
                </div>
              )}
              {!createMode && (
                <React.Fragment>
                  <div className="my-input-root">
                    <TextField className="w-100" name="contractor_id" label="版権者コード" disabled={true} InputProps={{ readOnly: true }}
                      defaultValue={shareGroup.contractor_id ? shareGroup.contractor_id : '指定なし'}/>
                  </div>
                  {shareGroup.contractor_id && (
                    <BootstrapAlert class="primary">
                      <div>新規契約の締結時に上記の版権者コードが設定されたとき、特に指定がない場合はこの共有グループが設定されます。</div>
                    </BootstrapAlert>
                  )}
                </React.Fragment>
              )}
            </div>
            <div className="col-6">
              <h5 className="mb-3">メンバー</h5>
              <BootstrapAlert class="danger">
                <b>追加したユーザー間では申請情報が共有できます。追加の際はご注意ください。</b>
              </BootstrapAlert>
              <div className={editMode ? '' : 'd-none'}>
                {MultipleSelector(shareGroup.share_group_members, getUsersNotInGroup(users), addList, setAddList, onAddButtonClick)}
              </div>
              <ul className="list-group sg-list bg-light minh-std">
                {memberList.map((member) => {
                  return (
                    <li className="list-group-item flex-column mx-2 my-1" key={member.id}>
                      <div className="row">
                        <div className="col-10 d-inline-block">
                          {editMode && member.nowMember && (
                            <span className="badge badge-primary mr-1">現メンバー</span>
                          )}
                          <span className='align-middle'>{member.name}【{member.company.name}】</span>
                        </div>
                        <div className="col-2">
                          {editMode && !member.is_me && (
                            <a href="#" className="badge badge-pill badge-danger float-right" onClick={(e) => {
                              removeMember(member.id)
                              e.preventDefault()
                            }}>&times;</a>
                          )}
                        </div>
                      </div>
                      <div className="float-right">{member.email}</div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-6"></div>
            <div className="col-6">
              {editMode
                ? (
              <React.Fragment>
                <button type="submit" id="update" className="btn bg-theme-primary float-right ml-2">{createMode ? '作成' : '更新'}</button>
                {!createMode && (
                  <button type="button" id="cancel" className="btn ol-theme-primary float-right ml-2"
                    onClick={(e) => {
                      e.preventDefault()
                      setEditMode(false)
                      setInTransit(true)
                    }}>キャンセル</button>
                )}
              </React.Fragment>
                  )
                : (editable &&
              <React.Fragment>
                <button type="button" id="edit" className="btn bg-theme-primary float-right ml-3" onClick={(e) => {
                  e.preventDefault()
                  setEditMode(true)
                  setInTransit(true)
                }}>編集</button>
                {props.deletable && (
                  <button type="button" id="destroy-dialog" className="btn btn-danger float-right ml-2" data-toggle="modal" data-target="#destroyModal">共有グループを削除</button>
                )}
                {/* -- 確認ダイアログ -- */}
                <div className="modal fade" id="destroyModal" tabIndex="-1" role="dialog" aria-labelledby="destroyModalLabel" aria-hidden="true">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="destroyModalLabel">共有グループの削除</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        削除したグループは元に戻せません。<br/><br/>
                        削除しますか？
                      </div>
                      <div className="modal-footer">
                        <button type="button" id="destroy" className="btn btn-danger float-right ml-3" onClick={(e) => {
                          e.preventDefault()
                          $.ajax({
                            url: postUrl.destroy,
                            type: 'POST',
                            dataType: 'json',
                            // フォーム要素の内容をハッシュ形式に変換
                            data: {
                              _token: $('meta[name="csrf-token"]').attr('content')
                            },
                            timeout: 10000,
                            success: (data, dataType) => {
                              location.href = data.redirect_url
                            },
                            error: (XMLHttpRequest, textStatus, errorThrown) => {
                              console.log(textStatus)
                              try {
                                const json = JSON.parse(XMLHttpRequest.responseText)
                                if (json && json.redirect_url) {
                                  location.href = json.redirect_url
                                }
                              } catch (error) {
                                console.log(XMLHttpRequest.responseText)
                              }
                            }
                          })
                        }}>削除</button>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
                  )}
            </div>
          </div>
        </React.Fragment>
        ),
        inTransit: inTransit
      })}
    </form>
  )
}

ShareGroupEdit.propTypes = {
  shareGroup: PropTypes.object,
  users: PropTypes.arrayOf(PropTypes.object),
  csrfToken: PropTypes.string,
  postUrl: PropTypes.object,
  createMode: PropTypes.bool,
  editable: PropTypes.bool,
  deletable: PropTypes.bool,
  isShopro: PropTypes.bool
}

ShareGroupEdit.defaultProps = {
  shareGroup: {
    id: -1,
    name: '',
    share_group_members: []
  },
  createMode: false,
  editable: false,
  deletable: true,
  isShopro: false
}

$('#share-group-edit').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <ShareGroupEdit {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
